import { Heading, Text, VStack } from "@chakra-ui/react";
import React from "react";

const DerivativeCard = ({ market, index_id, price, symbol }) => {
  return (
    <VStack
      width={"52"}
      bgColor={"blue.900"}
      shadow={"lg"}
      padding={"8"}
      borderRadius={"lg"}
      transition={"all 0.5s"}
      margin={"4"}
      css={{
        "&:hover": {
          transform: "scale(1.1)",
          backgroundColor: "blueviolet",
        },
      }}
    >
      <Heading size={"md"} noOfLines={1} color={"gold"}>
        {symbol}
      </Heading>
      <Heading size={"sm"} noOfLines={1}>
        {market}
      </Heading>
      <Text size={"sm"} noOfLines={1} fontWeight={"bold"}>
        {index_id}
      </Text>
      <Text size={"sm"} noOfLines={1}>Price: ${price}
      </Text>
    </VStack>
  );
};

export default DerivativeCard;
